import { render, staticRenderFns } from "./SalesManager.vue?vue&type=template&id=70ae6009&"
import script from "./SalesManager.vue?vue&type=script&lang=js&"
export * from "./SalesManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports